import { ApiUrlPrepare } from "@lib/helpers/ApiHelper";
import { API } from "@lib/services/http";
import { ApiParams, ApiResponse, PaginationType } from "@lib/types/Api";
import {
  AIWallet,
  AIWalletAddress,
  AIBlockchainPaymentHistory,
  AIBlockchainPayment,
} from "@lib/types/Wallet";

export const apiAddAIWallet = async (data: AIWallet) => {
  return API.post<AIWallet>(`/ai-wallet`, data);
};

export const apiDeleteAIWallet = async (data: AIWallet) => {
  return API.delete<null>(`/ai-wallet/${data.id}`);
};

export const apiUpdateAIWallet = async (data: AIWallet) => {
  const { id, ...rest } = data;
  return API.patch<AIWallet>(`/ai-wallet/${id}`, rest);
};

export const apiGetAIWallets = async <T extends ApiParams>(params: T) => {
  const url = ApiUrlPrepare({ params, url: `/ai-wallet` });
  return API.get<PaginationType<AIWallet>>(url);
};

export const apiAddMultipleAIWalletAddress = async (
  data: AIWalletAddress[],
) => {
  return API.post<AIWalletAddress[]>(`/ai-wallet-address/bulk`, data);
};

export const apiAddAIWalletAddress = async (data: AIWalletAddress) => {
  return API.post<AIWalletAddress>(`/ai-wallet-address`, data);
};

export const apiDeleteAIWalletAddress = async (data: AIWalletAddress) => {
  return API.delete<null>(`/ai-wallet-address/${data.id}`);
};

export const apiUpdateAIWalletAddress = async (
  data: Partial<AIWalletAddress>,
) => {
  const { id, ...rest } = data;
  return API.patch<AIWalletAddress>(`/ai-wallet-address/${id}`, rest);
};

export const apiGetAIWalletAddress = async <T extends ApiParams>(params: T) => {
  const url = ApiUrlPrepare({ params, url: `/ai-wallet-address` });
  return API.get<PaginationType<AIWalletAddress>>(url);
};

export const apiAddCreditToAIWalletAddress = async (
  id: string,
  amount: number,
) => {
  const url = `/ai-wallet-address/add-credit/${id}`;
  return API.post<ApiResponse>(url, { freeCredit: amount });
};

// #
// ####### ai-scanned-transaction #######
export const apiGetAIBlockchainPayments = async <T extends ApiParams>(
  params: T,
) => {
  const url = ApiUrlPrepare({ params, url: `/ai-scanned-transaction` });
  return API.get<PaginationType<AIBlockchainPayment>>(url);
};
export const apiAddAIBlockchainPaymentWalletAddress = async (id: string) => {
  const url = `/ai-scanned-transaction/scan/wallet-address/${id}`;
  return API.post<ApiResponse>(url);
};

// #
// ####### ai-transaction-history #######
export const apiGetAIBlockchainPaymentRequests = async <T extends ApiParams>(
  params: T,
) => {
  const url = ApiUrlPrepare({ params, url: `/ai-transaction-history` });
  return API.get<PaginationType<AIBlockchainPaymentHistory>>(url);
};

export const apiAddAIBlockchainPaymentRequest = async (
  data: Partial<AIBlockchainPaymentHistory>,
) => {
  return API.post<Partial<AIBlockchainPaymentHistory>>(
    `/ai-transaction-history`,
    data,
  );
};

export const apiAddAIBlockchainPaymentRequests = async (
  data: Partial<AIBlockchainPaymentHistory>[],
) => {
  return API.post<Partial<AIBlockchainPaymentHistory>[]>(
    `/ai-transaction-history/bulk`,
    {
      bulk: data,
    },
  );
};

export const apiDeleteAIBlockchainPaymentRequest = async (
  data: AIBlockchainPaymentHistory,
) => {
  return API.delete<null>(`/ai-transaction-history/${data.id}`);
};
